import { useMemo, type FC } from 'react';

import { useIsLargerThanWide } from '../../../../styles/hooks/media';
import {
  IconButtonSize,
  IconButtonWithTooltip,
  Icons,
  TooltipPositions,
} from '../../../controls/iconButton/IconButtonWithTooltip';
import { GameButtonWithTooltip } from '../../../game/gameButton/gameButton';
import type { TooltipProps } from '../../../tooltip/Tooltip';

interface QuickGuideControlPlainProps {
  onClick: () => void;
  active: boolean;
  timer: number;
}

export const QuickGuideControl: FC<QuickGuideControlPlainProps> = ({ active, timer, onClick }) => {
  const isWide = useIsLargerThanWide();

  const tooltipOptions: TooltipProps = useMemo(() => {
    return {
      text: 'QG_QUICK_GUIDE',
      position: isWide ? TooltipPositions.Bottom : TooltipPositions.Right,
      forceOpen: timer !== 0,
      displayOnTouch: true,
      displayTrigger: timer !== 0,
    };
  }, [isWide, timer]);

  return isWide ? (
    <IconButtonWithTooltip
      data-testid="quick-guide-button"
      icon={Icons.Guide}
      active={active}
      timer={timer}
      onClick={onClick}
      autoCall={false}
      size={!isWide ? IconButtonSize.LARGE : IconButtonSize.REGULAR}
      tooltipOptions={tooltipOptions}
    />
  ) : (
    <GameButtonWithTooltip
      data-testid="quick-guide-button"
      icon={Icons.Guide}
      active={active}
      onClick={onClick}
      timerDuration={timer}
      tooltipOptions={tooltipOptions}
    />
  );
};
